import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { useWorkspace } from "./features/workspace-context";
import { LoginPage } from "./pages/LoginPage";
import { ProfilePage } from "./pages/ProfilePage";
import { ProjectPage } from "./pages/ProjectPage";
import { ProjectPortfolioPage } from "./pages/ProjectPortfolioPage";

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <div className="loading-orbit">
        <span />
        <span />
        <span />
      </div>
      <strong>Construyendo la vista del roadmap…</strong>
    </div>
  );
}

export default function App() {
  const { session, loading, error, refresh, mode } = useWorkspace();
  if (loading) return <LoadingScreen />;
  if (!session && mode === "supabase") return <LoginPage />;
  if (error && !session) {
    return (
      <div className="fatal-screen">
        <span className="eyebrow">Error de arranque</span>
        <h1>No se pudo abrir el workspace.</h1>
        <p>{error}</p>
        <button className="button button--primary" type="button" onClick={() => void refresh()}>
          Reintentar
        </button>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<ProjectPortfolioPage />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="projects/:projectId/:view" element={<ProjectPage />} />
          <Route path="projects/:projectId" element={<ProjectPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
